<template>
  <div>
    <el-form class="category-attr" :model="formData" :rules="rules" ref="form" v-loading="loading">
      <template v-for="(item, idx) in attrs">
        <el-form-item
          :ref="item.idName"
          v-if="isShowFn(item)"
          :label="item.name"
          label-position="top"
          :prop="item.idName"
          :key="item.idName"
          :class="[
            'attr-item',
            'el-form-item-top',
            { 'three-item': item.controlType === 13, 'select-input-item': item.controlType === 16 },
          ]"
        >
          <!-- 选择框  values -->
          <el-select
            width="180px"
            v-if="[1, 3].includes(item.controlType)"
            class="select-wrp"
            placeholder="请选择"
            value-key="vid"
            clearable
            :value="formData[item.idName]"
            :data-id="item.idName"
            :key="idx"
            :filterable="item.chooseMaxNum === 1"
            :multiple="item.chooseMaxNum !== 1"
            :multiple-limit="item.chooseMaxNum"
            :allow-create="item.controlType === 3"
            :popper-append-to-body="false"
            @change="onSelectChange($event, item)"
          >
            <el-option
              v-for="(op, opidx) in item.options || item.values"
              :key="item.id + '-' + opidx + op.vid"
              :label="op.value"
              :value="op"
            >
            </el-option>
          </el-select>
          <!-- 输入框  -->
          <Input
            v-else-if="item.controlType === 0"
            :item="item"
            v-model="formData[item.idName]"
            :valueUnit="formatValueUnit(item.idName)"
            @changeUnits="changeUnits"
          />
          <!-- 日期选择 5 7 -->
          <el-date-picker
            v-if="[5, 7].includes(item.controlType)"
            width="180px"
            v-model="formData[item.idName]"
            :type="item.controlType === 5 ? 'date' : 'month'"
            placeholder="选择日期"
            :picker-options="{ disabledDate: time => disabledDate(item, time) }"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          <!-- 日期范围选择 6 8 -->
          <DateRange
            v-else-if="[6, 8].includes(item.controlType)"
            :item="item"
            :disabledDate="disabledDate"
            v-model="formData[item.idName]"
          />
          <!-- 颜色选择 9 -->
          <el-color-picker
            v-else-if="item.controlType === 9"
            style="width: 180px"
            class="color-picker"
            v-model="formData[item.idName]"
            show-alpha
          ></el-color-picker>
          <!-- 多输入框 11 12 13 -->
          <MultiInput
            v-else-if="[11, 12, 13].includes(item.controlType)"
            v-model="formData[item.idName]"
            :item="item"
            @changeUnits="changeUnits"
          />
          <SelectAndInputs v-else-if="item.controlType === 16" v-model="formData[item.idName]" :item="item" />
        </el-form-item>
      </template>
      <template>
        <span class="update-shop">
          找不到商品属性？
          <el-link :underline="false" @click="chooseShop">
            {{ shopId ? '切换店铺' : '选择店铺精确查找' }}
          </el-link>
        </span>
      </template>
    </el-form>
    <el-dialog title="选择该店铺下的品牌/属性" :visible.sync="chooseShopdialogVisible">
      <div>
        <el-radio-group v-model="shopId">
          <el-radio v-for="shop in shopList" :label="shop.id" :key="shop.id">
            {{ shop.shortTitle || shop.title }}
          </el-radio>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="chooseShopdialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Input from './Input.vue';
import DateRange from './DateRange.vue';
import MultiInput from './MultiInput.vue';
import SelectAndInputs from './SelectAndInputs.vue';
import { isChild, getAttrByParentId, getConditionItems } from '../../utils';
import { mapActions, mapGetters } from 'vuex';
import { cloneDeep, isEmpty } from 'lodash';

export default {
  components: {
    Input,
    DateRange,
    MultiInput,
    SelectAndInputs,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    initAttrData: {
      type: Array,
      default() {
        return [];
      },
    },
    categoryProperties: {
      type: Array,
      default() {
        return [];
      },
    },
    baseItemId: [Number, String],
    categoryId: [Number, String],
  },
  data() {
    return {
      platform: 'pddtemu',
      shopList: [],
      rules: {},
      attrs: [],
      formData: {},
      conditionsAttrs: [], // 受控类目属性
      parentIds: [], // 控制子集的父级refid
      loading: false, // 类目属性loading
      units: {},
      id: '',
      chooseShopdialogVisible: false,
      shopId: '',
      formDataTimer: null, // 防抖定时器
    };
  },
  computed: {
    ...mapGetters(['get_AllShops_BySource']),
  },
  watch: {
    categoryProperties: {
      handler(id) {
        this.updateFormData();
      },
      deep: true,
    },
    initAttrData: {
      handler(val) {
        this.updateFormData();
      },
      deep: true,
    },

    formData: {
      deep: true,
      handler(newVal, oldVal) {
        // 防抖处理，避免频繁触发
        if (this.formDataTimer) {
          clearTimeout(this.formDataTimer);
        }
        this.formDataTimer = setTimeout(() => {
          this.emitFormDataChange(newVal);
        }, 100);
      },
    },
    units: {
      deep: true,
      handler(newVal, oldVal) {
        // 只在真正变化时处理
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          this.updateUnits(newVal);
        }
      },
    },
  },
  methods: {
    // 优化的formData变化处理
    emitFormDataChange(formData) {
      const res = [];
      Object.entries(formData).forEach(([key, value]) => {
        const refPid = key.replace('name', '');
        const findAttr = this.attrs.find(c => c.refPid == refPid && this.isShowFn(c));
        if (!value || !findAttr) return;
        const baseData = { refPid: findAttr.refPid, templatePid: findAttr.templatePid, pid: findAttr.pid, propName: findAttr.name };
        if (Array.isArray(value)) {
          value.forEach(item => {
            res.push({ ...item, vid: item.vid ? Number(item.vid) : '', ...baseData });
          });
        } else {
          // 兼容日期选择等对象类型
          const propValue = typeof value === 'object' ? value.propValue : value;
          const vid = value.vid;
          if (propValue) {
            res.push({
              propValue,
              vid: vid ? Number(vid) : '',
              valueUnit: this.units[key] || '',
              ...baseData,
            });
          }
        }
      });
      this.$emit('change', res);
    },
    // 优化的units更新处理
    updateUnits(units) {
      for (let key in units) {
        const refPid = key.replace('name', '');
        const item = this.value.find(it => it.refPid === refPid);
        if (item) {
          item.valueUnit = units[key];
        }
      }
      this.$emit('change', this.value);
    },
    isShowFn(item) {
      const { showCondition, templatePropertyValueParentList, refPid, parentTemplatePid } = item;
      // 1. 处理 showCondition
      if (Array.isArray(showCondition) && showCondition.length) {
        for (const condition of showCondition) {
          const refPidName = `${condition.parentRefPid}name`;
          let value = cloneDeep(this.formData[refPidName]);
          if (value && !Array.isArray(value)) value = [value];

          if (Array.isArray(value) && value.length > 0 && condition.parentVids.some(vid => value.some(v => v.vid === vid))) {
            return true;
          }
        }
        return false;
      }
      if (templatePropertyValueParentList?.length && parentTemplatePid) {
        const selectedVids = Object.values(this.formData)
          .reduce((acc, v) => {
            const arr = Array.isArray(v) ? v : (v ? [v] : []);
            arr.forEach(val => {
              if (val && val.templatePid === parentTemplatePid && val.vid) acc.push(val.vid);
            });
            return acc;
          }, []);
        if (!selectedVids.length) return false;
        for (const tpl of templatePropertyValueParentList) {
          const { parentVidList, vidList } = tpl;
          if (Array.isArray(parentVidList) && parentVidList.some(p => selectedVids.includes(p))) {
            // 只在找到当前属性时才赋值
            const curAttr = this.attrs.find(attr => attr.refPid === refPid);
            if (curAttr && Array.isArray(curAttr.originValues)) {
              curAttr.options = curAttr.originValues.filter(op => vidList.includes(op.vid));
            }
            return true;
          }
        }
        return false;
      } 
      // 3. 默认显示
      return true;
    },
    validatorAttr(rule, value, callback) {
      // 临时修复日期类型组件填入后校验未通过问题
      if (!value || (typeof value === 'object' && !Array.isArray(value) && !value.propValue)) {
        callback(new Error(''));
      } else {
        callback();
      }
    },
    confirm() {
      if (!this.shopId) {
        this.$message.warning('请选择店铺');
        return;
      }
      this.$emit('switchShop', this.shopId);
      this.chooseShopdialogVisible = false;
    },
    updateFormData() {
      const data = this.categoryProperties;
      if (data && data.length) {
        this.$refs?.form?.clearValidate()
        let rules = {};
        this.attrs = data.map(item => {
          if (item.templatePropertyValueParentList?.length) {
            item.originValues = JSON.parse(JSON.stringify(item.values || []));
          }

          item.idName = item.refPid + 'name';
          // 校验rules
          const text = this.isSelect(item) ? '请选择' : '请输入';
          if (item.required) {
            rules[item.idName] = [
              { required: true, message: text + item.name, trigger: 'change' },
              { validator: this.validatorAttr, message: text + item.name, trigger: 'change' },
            ];
          }
          // 下拉选择框：校验回显值是否在选项范围内
          if ([1, 3].includes(item.controlType) && (item.options || item.values)) {
            const existingRules = rules[item.idName] || [];
            existingRules.push({
              validator: (_rule, value, callback) => {
                if (!value) return callback();
                const opts = item.options || item.values || [];
                if (!opts.length) return callback();
                const isValid = Array.isArray(value)
                  ? value.every(v => opts.some(op => op.vid === v.vid))
                  : opts.some(op => op.vid === value.vid);
                if (!isValid) {
                  return callback(new Error('当前值已失效，请重新选择'));
                }
                callback();
              },
              trigger: 'change',
            });
            rules[item.idName] = existingRules;
          }
          if (item.controlType === 16) {
            rules[item.idName] = [
              { required: true, message: text + item.name, trigger: 'change' },
              {
                validator: (rule, value, callback) => {
                  let sum = 0;
                  (value || []).map(v => (sum += Number(v.numberInputValue)));
                  if (sum !== 100) {
                    return callback(new Error('所有比例之和需等于100%'));
                  }
                  return callback();
                },
              },
            ];
          }
          // 通过initAttrData设置输入框的值
          let val = '';
          const valueItems = this.initAttrData.filter(it => it.refPid == item.refPid);
          if (valueItems.length) {
            const attrValueItem = valueItems[0];
            if (item.values && item.values.length) {
              if (item.chooseMaxNum !== 1 || item.controlType === 16) {
                val = [];
                valueItems.forEach(va => {
                  if ((va.propValue || '').indexOf(',') !== -1) {
                    let vArr = va.propValue.split(',');
                    let vidArr = va.vid.split(',');
                    vArr.forEach((iv, iidx) => {
                      val.push({
                        ...va,
                        propValue: iv,
                        vid: Number(vidArr[iidx]),
                        propName: item.name,
                        templatePid: item.templatePid,
                        pid: item.pid,
                      });
                    });
                  } else {
                    val.push({
                      ...va,
                      vid: Number(va.vid),
                      propValue: va.propValue,
                      propName: item.name,
                      templatePid: item.templatePid,
                      pid: item.pid,
                    });
                  }
                });
              } else {
                val = attrValueItem;
              }
            } else {
              val = attrValueItem.propValue;
              if ([0, 11, 12, 13].includes(item.controlType) && item.valueUnit?.length && item.valueUnit[0]) {
                this.units[item.idName] = item.valueUnit[0];
              }
              // 组合字段需要特殊处理
              if ([11, 12, 13].includes(item.controlType)) {
                const specEnum = {
                  0: 'one',
                  1: 'two',
                  2: 'three',
                  3: 'four',
                };
                const newVal = {};
                (val || '').split(',').forEach((item, index) => {
                  newVal[specEnum[index]] = item;
                });
                newVal.propValue = val;
                val = newVal;
              }
            }
          }
          if (item.controlType === 16 && !Array.isArray(val)) {
            val = [];
          }
          // 设置默认值
          if (!val) {
            // 数字类型输入框处理
            if (item.propertyValueType === 1 && item.minValue) {
              val = Number(item.minValue);
            }
          } else {
            // 如果有值并且有控制其他输入框，isParent:true
            // let childIdx = getAttrByParentId(data, item.refPid);
            // if (childIdx.length) {
            //   shouldUpdateChild.push({ ...item, val: val });
            // }
          }
          this.$set(this.formData, item.idName, val);
          return item;
        });
        // 如果父级有值，则子级应该显示
        // shouldUpdateChild.forEach(item => {
        //   this.onSelectChange(item.val, item);
        // });
        this.rules = rules;
        this.$nextTick(() => {
          this.validate();
        });
      }
    },
    isSelect(item) {
      return item.values;
    },
    formatValueUnit(idName) {
      const matchItem = this.initAttrData.find(item => {
        return `${item.refPid}` === idName.replace(/name/g, '');
      });
      if (matchItem) {
        return matchItem.valueUnit;
      }
      return '';
    },
    disabledDate(item, time) {
      time = time.getTime();
      if (item.valueType === 5 || item.valueType === 4) {
        let min = item.minValue;
        let max = item.maxValue;
        if (min) min = new Date(min);
        if (max) max = new Date(max);
        if (min && max) {
          return !(time > min.getTime() && time < max.getTime());
        } else if (min) {
          return !(time > min.getTime());
        } else if (max) {
          return !(time < max.getTime());
        }
      }
      return false;
    },
    onSelectChange(val, item) {
      // 统一格式化val
      let newVal;
      if (Array.isArray(val)) {
        newVal = val.map(v => ({
          refPid: item.refPid,
          templatePid: item.templatePid,
          pid: item.pid,
          propName: item.name,
          propValue: v.value || v.propValue,
          vid: v.vid,
        }));
      } else if (val) {
        newVal = {
          refPid: item.refPid,
          templatePid: item.templatePid,
          pid: item.pid,
          propName: item.name,
          propValue: val.value || val.propValue,
          vid: val.vid,
        };
      } else {
        newVal = null;
      }
      this.$set(this.formData, item.idName, newVal);
      return;
      const refPid = item.refPid;
      if (!this.parentIds.includes(refPid)) return;

      const attrs = [...this.attrs];
      let parentAttr = attrs.find(i => i.refPid === refPid);
      // attrs.forEach((attr, aIdx) => {
      //   if (isChild(item, attr) && item.values && !Array.isArray(newVal)) {
      //     // 如果为item的子级
      //     const conItems = getConditionItems(this.conditionsAttrs, item, newVal); // 在所有子级中找到符合条件的子级
      //     const idx = conItems.findIndex(it => it.refPid === attr.refPid);

      //     if (idx !== -1 && parentAttr && parentAttr.visible !== false) {
      //       // 当前attr需要显示的子级
      //       // conItems[idx].values
      //       attrs[aIdx].options = conItems[idx].options;
      //       attrs[aIdx].visible = true;

      //       // 如果当前下拉框选择的值没有在options下拉列表中，则清空

      //       const curVal = this.formData[attr.idName];
      //       if (Array.isArray(curVal) && curVal.length) {
      //         const filterVals = curVal.filter(valItem => conItems[idx].options?.findIndex(op => op.value === valItem.propValue));
      //         this.$set(this.formData, attr.idName, filterVals);
      //       } else if (curVal) {
      //         const valIdx = conItems[idx].options?.findIndex(op => op.value === curVal.propValue);
      //         if (valIdx === -1) {
      //           this.$set(this.formData, attr.idName, null);
      //         }
      //       }
      //     } else {
      //       attr.visible = false;
      //       this.$set(this.formData, attr.idName, null);
      //     }
      //   }
      // });
      // this.attrs = attrs;
    },

    changeUnits(unit) {
      this.units = { ...this.units, ...unit };
    },
    validate() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          resolve(valid);
        });
      });
    },

    chooseShop() {
      this.chooseShopdialogVisible = true;
    },
  },
  mounted() {
    this.shopList = this.get_AllShops_BySource(this.platform);
  },
  beforeDestroy() {
    // 清理定时器，防止内存泄露
    if (this.formDataTimer) {
      clearTimeout(this.formDataTimer);
      this.formDataTimer = null;
    }
  },
};
</script>

<style lang="scss" scoped>
.category-attr {
  position: relative;
  padding-bottom: 20px;
  .smart-match-tip {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 2px;
    padding: 10px;
    font-size: 14px;
    width: 100%;
    color: #6c6d6f;
    .icon {
      color: #faad14;
      font-size: 24px;
      margin-right: 5px;
    }
    .match-infos {
      font-size: 12px;
      margin-left: 30px;
    }
    .fill-btn {
      margin-right: 30px;
    }
    .delete-btn {
      position: absolute;
      top: 10px;
      right: 20px;
      color: #979494;
    }
  }
  ::v-deep .el-select .el-input {
    width: 100% !important;
  }
  .el-select-dropdown {
    min-width: 180px;
  }
  .color-picker {
    ::v-deep .el-color-picker__trigger {
      width: 100px;
    }
  }
  .select-input-item {
    width: 100% !important;
  }
  .hide-item {
    display: none;
  }
  .select-wrp {
    ::v-deep .el-select-dropdown {
      min-width: 180px;
    }
  }
  .el-form-item-top {
    display: flex;
    flex-direction: column;
    ::v-deep .el-form-item__label {
      text-align: left;
    }
  }
  .update-shop {
    position: absolute;
    left: 20px;
    bottom: 0px;
    font-size: 12px;
  }
}
</style>
